export const init3DLink = ( apartmentCard ) => {
	const linkTo3D = apartmentCard.querySelector( 'a.to-3d' );

	if ( !linkTo3D )
	{
		return;
	}

	linkTo3D.addEventListener( 'click', ( evt ) => {
		evt.preventDefault();

		const initialDistance = Math.round( document.querySelector( 'section.cds2-apartment-virtual-tour' ).getBoundingClientRect().top - document.querySelector( 'header' ).offsetHeight - 20 );
		let closedDistance = 0;

		const pathInterval = setInterval( () => {
			const diff = initialDistance - closedDistance;

			if ( diff > 0 )
			{
				window.scrollBy( 0, diff > 50 ? 50 : diff );
				closedDistance += 50;
			}
			else
			{
				clearInterval( pathInterval );
			}
		}, 10 );
	} );
};